import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import './ArthiksakhaKhandShreniWiseSummary.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row, Modal, Button } from "react-bootstrap"; // ✅ Added Modal & Button
import useAuth from "../../hooks/useAuth";
import { useRef } from "react";
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import { fetchPranthList } from './pranthService'; // Adjust path as needed
import "./../summeryTableStyle.css"


const ArthiksakhaKhandShreniWiseSummary = () => {

  const { auth, persist } = useAuth();
  const [gurudakshinas, setGurudakshinas] = useState([]);

  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const gurudakshinaPerPage = 50;
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const [khandList, setKhandList] = useState([]);
  const [selectedKhandId, setSelectedKhandId] = useState("");
  const [loading, setLoading] = useState(true);

  const [hasSearched, setHasSearched] = useState(false); // 👈 NEW


  const fetchKhands = useCallback(async () => {
    if (!auth?.level_id) return;

    try {
      const res = await axiosPrivate.get(`list-khands-in-arthik-sakha?arthik_sakha_id=${auth?.level_id}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setKhandList(data);

    } catch (err) {
      console.error("Khand fetch failed:", err);
      setError("Failed to load Khand list");
      setKhandList([]);
      setSelectedKhandId("");
    }
  }, [axiosPrivate, auth?.level_id]);

  useEffect(() => {
    if (auth?.level_id) {
      fetchKhands();
    }
  }, [auth?.level_id]);



  const fetchArppanSummary = useCallback(async () => {
    if (!selectedKhandId) return;  // 🛑 Prevent API call if undefined or empty
    setLoading(true);
    setError(null);
    setHasSearched(true);
    try {
      const url = `get-khand-arppan-summary?khand_id=${selectedKhandId}`;
      const response = await axiosPrivate.get(url, { withCredentials: true });
      setLoading(false);
      if (response.status === 204) {
        // ✅ No Content case
        setGurudakshinas([]);
        setLoading(false);
        setError("No Data available.");
        return;
      }

      // ✅ Handle valid data
      // setGurudakshinas(Array.isArray(response.data) ? response.data : []);
      setGurudakshinas(response.data);


    } catch (error) {
      console.error("Error fetching Data:", error);
      setError(error?.response?.data?.message || "No Data available.");
      setGurudakshinas([]); // Clear old data in case of error
      setLoading(false);
    }
  }, [axiosPrivate, selectedKhandId]);

  const summaryData = gurudakshinas?.data || [];

  const vs = summaryData.find(item => item.sakha === "Vidyarthi Samyuktha");
  const vt = summaryData.find(item => item.sakha === "Vidyarthi Tharuna");
  const vy = summaryData.find(item => item.sakha === "Vyavasayi Tharuna");
  const pr = summaryData.find(item => item.sakha === "Prouda");



  useEffect(() => {
    fetchArppanSummary();
  }, [selectedKhandId]);



  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  // if (loading) {
  //   return <div className="loading">Loading...</div>;
  // }

  return (
    <>
      <style>{`
  #customers th, #customers td {

    min-width: 144px;
  }`}</style>

      <section className="empbody">
        <div className="wrapperemp2">
          {/* ✅ Finalize Button with Modal trigger */}
          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>

          <div
          // className="d-flex justify-content-end align-items-center gap-2 mb-3"
          ></div>
          <h3>Khand Summary</h3>

          <Row>
            <Col md={12}>
              <Form.Label className="newformstyle">Select Khand</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedKhandId}
                onChange={(e) => setSelectedKhandId(e.target.value)}
              >
                <option value="">-- Select Khand --</option>
                {khandList.map((k) => (
                  <option key={k.khand_id} value={k.khand_id}>
                    {k.khand_name}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>

          <div
          // className="table-container"
          >

            {hasSearched && (
              <div className="table-container">
                {hasSearched && (
                  <table id="customers" className="table table-bordered text-center summary-table">
                    <thead>
                      <tr>
                        <th colSpan={1} className="text-center">
                          SHRENI
                        </th>
                        <th colSpan={5} className="text-center">
                          UPASTHITHI/THUKA
                        </th>
                      </tr>
                      <tr>
                        <th rowSpan={2}></th>
                        <th>VIDHYARTHI SAMYUKTHA</th>
                        <th>VIDHYARTHI THARUNA</th>
                        <th>VYAVASAYI THARUNA</th>
                        <th>PROUDA</th>
                        <th>TOTAL</th>
                      </tr>
                      <tr>
                        <th>({gurudakshinas?.vs_uthsavam ?? 0})</th>
                        <th>({gurudakshinas?.vt_uthsavam ?? 0})</th>
                        <th>({gurudakshinas?.vy_uthsavam ?? 0})</th>
                        <th>({gurudakshinas?.pr_uthsavam ?? 0})</th>
                        <th>({gurudakshinas?.uthsavam ?? 0})</th>
                      </tr>
                    </thead>

                    <tbody><tr>
                      <th>SISU</th>

                      <td>
                        <div>{vs?.sisu ?? 0}</div>
                        <div className="amount">
                          ₹{Number(vs?.sisuAmount ?? 0).toLocaleString("en-IN")}
                        </div>
                      </td>

                      <td>
                        <div> {vt?.sisu ?? 0}</div>
                        <div className="amount">
                          ₹{Number(vt?.sisuAmount ?? 0).toLocaleString("en-IN")}
                        </div>



                      </td>

                      <td>

                        <div> {vy?.sisu ?? 0}</div>
                        <div className="amount">
                          ₹{Number(vy?.sisuAmount ?? 0).toLocaleString("en-IN")}
                        </div>


                      </td>

                      <td>
                        <div> {pr?.sisu ?? 0}</div>
                        <div className="amount">
                          ₹{Number(pr?.sisuAmount ?? 0).toLocaleString("en-IN")}
                        </div>



                      </td>

                      <td>
                        {(vs?.sisu ?? 0) +
                          (vt?.sisu ?? 0) +
                          (vy?.sisu ?? 0) +
                          (pr?.sisu ?? 0)}
                        <br />
                        ₹
                        {(
                          Number(vs?.sisuAmount ?? 0) +
                          Number(vt?.sisuAmount ?? 0) +
                          Number(vy?.sisuAmount ?? 0) +
                          Number(pr?.sisuAmount ?? 0)
                        ).toLocaleString("en-IN")}
                      </td>
                    </tr>
                      <tr>
                        <th>BALA</th>

                        <td>
                          {vs?.bala ?? 0}
                          <div className="amount">
                            ₹{Number(vs?.balaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vt?.bala ?? 0}
                          <div className="amount">
                            ₹{Number(vt?.balaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vy?.bala ?? 0}
                          <div className="amount">
                            ₹{Number(vy?.balaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {pr?.bala ?? 0}
                          <div className="amount">
                            ₹{Number(pr?.balaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {(vs?.bala ?? 0) +
                            (vt?.bala ?? 0) +
                            (vy?.bala ?? 0) +
                            (pr?.bala ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vs?.balaAmount ?? 0) +
                            Number(vt?.balaAmount ?? 0) +
                            Number(vy?.balaAmount ?? 0) +
                            Number(pr?.balaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>
                      </tr>

                      <tr>
                        <th>VIDHYARTHI THARUNA</th>

                        <td>
                          {vs?.vtharuna ?? 0}
                          <div className="amount">
                            ₹{Number(vs?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vt?.vtharuna ?? 0}
                          <div className="amount">
                            ₹{Number(vt?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vy?.vtharuna ?? 0}
                          <div className="amount">
                            ₹{Number(vy?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {pr?.vtharuna ?? 0}
                          <div className="amount">
                            ₹{Number(pr?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {(vs?.vtharuna ?? 0) +
                            (vt?.vtharuna ?? 0) +
                            (vy?.vtharuna ?? 0) +
                            (pr?.vtharuna ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vs?.vtharunaAmount ?? 0) +
                            Number(vt?.vtharunaAmount ?? 0) +
                            Number(vy?.vtharunaAmount ?? 0) +
                            Number(pr?.vtharunaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>
                      </tr>

                      <tr>
                        <th>VYAVASAYI THARUNA</th>

                        <td>
                          {vs?.tharuna ?? 0}
                          <div className="amount">
                            ₹{Number(vs?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vt?.tharuna ?? 0}
                          <div className="amount">
                            ₹{Number(vt?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vy?.tharuna ?? 0}
                          <div className="amount">
                            ₹{Number(vy?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {pr?.tharuna ?? 0}
                          <div className="amount">
                            ₹{Number(pr?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {(vs?.tharuna ?? 0) +
                            (vt?.tharuna ?? 0) +
                            (vy?.tharuna ?? 0) +
                            (pr?.tharuna ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vs?.tharunaAmount ?? 0) +
                            Number(vt?.tharunaAmount ?? 0) +
                            Number(vy?.tharunaAmount ?? 0) +
                            Number(pr?.tharunaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>
                      </tr>
                      <tr>
                        <th>PROUDA</th>

                        <td>
                          {vs?.prouda ?? 0}
                          <div className="amount">
                            ₹{Number(vs?.proudaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vt?.prouda ?? 0}
                          <div className="amount">
                            ₹{Number(vt?.proudaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vy?.prouda ?? 0}
                          <div className="amount">
                            ₹{Number(vy?.proudaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {pr?.prouda ?? 0}
                          <div className="amount">
                            ₹{Number(pr?.proudaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {(vs?.prouda ?? 0) +
                            (vt?.prouda ?? 0) +
                            (vy?.prouda ?? 0) +
                            (pr?.prouda ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vs?.proudaAmount ?? 0) +
                            Number(vt?.proudaAmount ?? 0) +
                            Number(vy?.proudaAmount ?? 0) +
                            Number(pr?.proudaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>
                      </tr>
                      <tr>
                        <th>TOTAL</th>

                        <td>
                          {(vs?.sisu ?? 0) +
                            (vs?.bala ?? 0) +
                            (vs?.vtharuna ?? 0) +
                            (vs?.tharuna ?? 0) +
                            (vs?.prouda ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vs?.sisuAmount ?? 0) +
                            Number(vs?.balaAmount ?? 0) +
                            Number(vs?.vtharunaAmount ?? 0) +
                            Number(vs?.tharunaAmount ?? 0) +
                            Number(vs?.proudaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>

                        <td>
                          {(vt?.sisu ?? 0) +
                            (vt?.bala ?? 0) +
                            (vt?.vtharuna ?? 0) +
                            (vt?.tharuna ?? 0) +
                            (vt?.prouda ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vt?.sisuAmount ?? 0) +
                            Number(vt?.balaAmount ?? 0) +
                            Number(vt?.vtharunaAmount ?? 0) +
                            Number(vt?.tharunaAmount ?? 0) +
                            Number(vt?.proudaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>

                        <td>
                          {(vy?.sisu ?? 0) +
                            (vy?.bala ?? 0) +
                            (vy?.vtharuna ?? 0) +
                            (vy?.tharuna ?? 0) +
                            (vy?.prouda ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vy?.sisuAmount ?? 0) +
                            Number(vy?.balaAmount ?? 0) +
                            Number(vy?.vtharunaAmount ?? 0) +
                            Number(vy?.tharunaAmount ?? 0) +
                            Number(vy?.proudaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>

                        <td>
                          {(pr?.sisu ?? 0) +
                            (pr?.bala ?? 0) +
                            (pr?.vtharuna ?? 0) +
                            (pr?.tharuna ?? 0) +
                            (pr?.prouda ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(pr?.sisuAmount ?? 0) +
                            Number(pr?.balaAmount ?? 0) +
                            Number(pr?.vtharunaAmount ?? 0) +
                            Number(pr?.tharunaAmount ?? 0) +
                            Number(pr?.proudaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>

                        <td>
                          {(vs?.totalUpasthith ?? 0) +
                            (vt?.totalUpasthith ?? 0) +
                            (vy?.totalUpasthith ?? 0) +
                            (pr?.totalUpasthith ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vs?.totalAmount ?? 0) +
                            Number(vt?.totalAmount ?? 0) +
                            Number(vy?.totalAmount ?? 0) +
                            Number(pr?.totalAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )}
              </div>
            )}
          </div>
        </div >
      </section >

      <TopBar />
    </>
  );
};

export default ArthiksakhaKhandShreniWiseSummary;
